export default {
  tableHeader: 'Pola niestandardowe',
};
